"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const effects_1 = require("redux-saga/effects");
const tags_1 = require("companion-app-components/flux/tags");
const auth_1 = require("companion-app-components/flux/auth");
const core_actions_1 = require("companion-app-components/flux/core-actions");
const datasets_1 = require("companion-app-components/flux/datasets");
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const transactions_1 = require("companion-app-components/flux/transactions");
const budget_items_1 = require("companion-app-components/flux/budget-items");
const budgetsActions_1 = require("companion-app-components/flux/budgets/budgetsActions");
const renameRulesActions_1 = require("companion-app-components/flux/rename-rules/renameRulesActions");
const actions_1 = require("companion-app-components/flux/investmentHoldings/actions");
const npsActions_1 = require("companion-app-components/flux/nps/npsActions");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const core_1 = require("companion-app-components/utils/core");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const actions_2 = require("companion-app-components/flux/preferences/actions");
const categoryGroupsActions_1 = require("companion-app-components/flux/category-groups/categoryGroupsActions");
const categoryGroupListsActions_1 = require("companion-app-components/flux/category-group-lists/categoryGroupListsActions");
const sharesActions = __importStar(require("companion-app-components/flux/dataset-shares/datasetSharesActions"));
const entitlements_1 = require("companion-app-components/flux/entitlements");
const userInfoActions = __importStar(require("companion-app-components/flux/user-info/userInfoActions"));
const documentsActions_1 = require("companion-app-components/flux/documents/documentsActions");
const preferencesV2Actions_1 = require("companion-app-components/flux/preferences-v2/preferencesV2Actions");
const memorizedRulesActions_1 = require("companion-app-components/flux/memorized-rules/memorizedRulesActions");
const accountGroupUtils_1 = require("companion-app-components/flux/account-groups/accountGroupUtils");
const accountGroupsActions_1 = require("companion-app-components/flux/account-groups/accountGroupsActions");
const balCache_1 = require("data/accountBalances/balCache");
const actions_3 = require("data/jobStatus/actions");
const subscriptionsActions_1 = require("data/subscriptions/subscriptionsActions");
const actions_4 = require("data/institutionLogins/actions");
const actions_5 = require("data/accounts/actions");
const initialize_1 = require("utils/featureFlags/initialize");
const actions_6 = require("data/app/actions");
const mcRulesActions_1 = require("data/mcRules/mcRulesActions");
const syncSentimentActions_1 = require("data/syncSentiment/syncSentimentActions");
const NavigateSetter_1 = require("NavigateSetter");
const axiosFactory_1 = __importDefault(require("utils/axiosFactory"));
const actions = __importStar(require("./actions"));
const qcsAxios = axiosFactory_1.default.get('qcs');
const log = (0, core_1.getLogger)('data/app/sagas.js');
function* appHistoryPush(action) {
    const { payload: { location } } = action;
    // @ts-expect-error: No overload matches this call.
    yield (0, effects_1.put)((0, NavigateSetter_1.navigate)(location));
}
function* appHistoryReplace(action) {
    const { payload: { location } } = action;
    // @ts-expect-error: No overload matches this call.
    yield (0, effects_1.put)((0, NavigateSetter_1.navigate)(location, { replace: true }));
}
function* fetchUserLevelData() {
    log.log('fetch data (user level)...');
    yield (0, effects_1.put)((0, subscriptionsActions_1.getSubscriptions)());
    yield (0, effects_1.put)(entitlements_1.entitlementsActions.getEntitlements());
    yield (0, effects_1.put)(datasets_1.datasetsActions.getDatasets());
    yield (0, effects_1.put)((0, actions_2.getPreferences)({ section: 'shared', group: 'user' }));
    yield (0, effects_1.put)(sharesActions.getDatasetShares());
}
function* fetchInstitutionLoginsIfAnyConnectedAccountExists() {
    // Accounts are fetched asynchronously; wait for success/failure before selecting from store.
    const { accountsLoaded } = yield (0, effects_1.race)({
        accountsLoaded: (0, effects_1.take)(accounts_1.accountsActions.getAccountsSuccess),
        accountsLoadFailed: (0, effects_1.take)(accounts_1.accountsActions.getAccountsFailure),
    });
    if (!accountsLoaded) {
        // Skip institution-login fetch if accounts failed to load in this cycle.
        return;
    }
    const allAccountsById = yield (0, effects_1.select)(accounts_1.accountsSelectors.getAccountsById);
    // Fetch institution logins only when at least one account is a connected FI account.
    const hasConnectedAccountWithInstitutionLoginId = allAccountsById.some((account) => (account === null || account === void 0 ? void 0 : account.isConnected) && (account === null || account === void 0 ? void 0 : account.institutionLoginId) && account.institutionLoginId !== '0');
    if (hasConnectedAccountWithInstitutionLoginId) {
        yield (0, effects_1.put)((0, actions_4.getInstitutionLogins)());
    }
}
function* fetchData() {
    log.log('fetch data (common)...');
    yield (0, effects_1.call)(balCache_1.clearBalancesCache);
    yield (0, effects_1.put)((0, preferencesV2Actions_1.getPreferencesV2)());
    yield (0, effects_1.put)((0, actions_2.getPreferences)({ section: 'shared', group: 'dataset' }));
    yield (0, effects_1.put)(accounts_1.accountsActions.getAccounts());
    yield (0, effects_1.call)(fetchInstitutionLoginsIfAnyConnectedAccountExists);
    yield (0, effects_1.put)(tags_1.tagsActions.getTags());
    yield (0, effects_1.put)(categories_1.categoriesActions.getCategories());
    yield (0, effects_1.put)((0, documentsActions_1.getDocuments)());
    yield (0, effects_1.put)(transactions_1.transactionsActions.getTransactions());
    yield (0, effects_1.put)((0, accountGroupsActions_1.getAccountGroups)());
}
function* fetchFeaturedData() {
    log.log('fetch data (featured)...');
    const featureFlags = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getFeatureFlags);
    yield (0, effects_1.put)((0, actions_5.getInvestmentAccounts)());
    yield (0, effects_1.put)((0, actions_1.getInvestmentHoldings)());
    if (featureFlags.get('nps')) {
        yield (0, effects_1.put)((0, npsActions_1.checkIfNPSSurveyRequestedAction)());
    }
    if (featureFlags.get('syncSentiment')) {
        yield (0, effects_1.put)((0, syncSentimentActions_1.checkIfSyncSentimentSurveyRequestedAction)());
    }
    if (featureFlags.get('mcp')) {
        yield (0, effects_1.put)((0, mcRulesActions_1.mcRulesExecute)());
    }
    let currentDataset = yield (0, effects_1.select)(auth_1.authSelectors.getCurrentDataset);
    while (!currentDataset || !currentDataset.entitlements) {
        yield (0, effects_1.delay)(100);
        currentDataset = yield (0, effects_1.select)(auth_1.authSelectors.getCurrentDataset);
    }
    const { isEntityShare } = (0, accountGroupUtils_1.getDatasetAccessControlData)(currentDataset);
    if (!isEntityShare && featureFlags.get('budgets')) {
        yield (0, effects_1.put)((0, budgetsActions_1.getBudgetsAction)());
        yield (0, effects_1.put)(budget_items_1.budgetItemsActions.getBudgetItemsAction());
        yield (0, effects_1.put)((0, categoryGroupsActions_1.getCategoryGroupsAction)());
        yield (0, effects_1.put)((0, categoryGroupListsActions_1.getCategoryGroupListsAction)());
    }
    if (!isEntityShare && (featureFlags.get('scheduledTransactions') || featureFlags.get('scheduledTransactionsInRegister'))) {
        yield (0, effects_1.put)(scheduled_transactions_1.scheduledTransactionsActions.getScheduledTransactions());
    }
    if (featureFlags.get('showMemorizedTransactionsSettings') || featureFlags.get('rules')) {
        yield (0, effects_1.put)((0, memorizedRulesActions_1.getMemorizedRules)());
    }
    if (!isEntityShare && (featureFlags.get('showRenameRulesSettings') || featureFlags.get('rules'))) {
        yield (0, effects_1.put)((0, renameRulesActions_1.getRenameRules)());
    }
}
function* startRefreshAccounts(payload) {
    log.log('accounts refresh triggered...');
    yield (0, effects_1.put)((0, actions_4.refreshAccounts)(payload));
    const datasetId = yield (0, effects_1.select)(auth_1.authSelectors.getDatasetId);
    const now = Date.now();
    core_1.localPreferences.setItem(`${datasetId}_last_auto_refresh_time`, now.toString());
}
function* appRefreshAll(action) {
    var _a, _b;
    log.info('refresh (start)->');
    const authTokenValid = yield (0, effects_1.select)(auth_1.authSelectors.isAuthTokenValid);
    if (!authTokenValid) {
        log.warn('refresh (invalid auth token) X');
    }
    else {
        // fetch user level data
        yield (0, effects_1.call)(fetchUserLevelData);
        const datasetId = yield (0, effects_1.select)(auth_1.authSelectors.getDatasetId);
        if (datasetId) {
            yield (0, effects_1.put)(core_actions_1.coreActions.setUpdateAllState({
                updateAllFailed: null,
                updateAllMessages: null,
            }));
            // if create job status fails, don't retry just continue loading
            yield (0, effects_1.put)((0, actions_3.createJobStatus)({ type: 'SYNC', datasetId }, { attemptsLeft: 0 }));
            const { createJobStatusSuccessAction } = yield (0, effects_1.race)({
                createJobStatusSuccessAction: (0, effects_1.take)(actions_3.createJobStatusSuccess),
                createJobStatusFailureAction: (0, effects_1.take)(actions_3.createJobStatusFailure),
            });
            // fetch data
            yield (0, effects_1.call)(fetchData);
            // fetch featured data
            const featureFlagsLoadPending = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getLoadPending);
            if (!featureFlagsLoadPending) {
                yield (0, effects_1.call)(fetchFeaturedData);
            }
            else {
                const featureFlagsIsLoading = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getIsLoading);
                if (!featureFlagsIsLoading) {
                    yield (0, effects_1.call)(initialize_1.initializeFeatureFlags);
                }
                yield (0, effects_1.fork)(function* waitForFlags() {
                    yield (0, effects_1.race)([
                        (0, effects_1.take)(feature_flags_1.featureFlagsActions.getFeatureFlagsSuccess),
                        (0, effects_1.take)(feature_flags_1.featureFlagsActions.getFeatureFlagsFailure),
                    ]);
                    yield (0, effects_1.call)(fetchFeaturedData);
                });
            }
            // trigger fi refresh
            let refreshStarted;
            if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.context) === 'init') {
                const lastRefreshTimeStr = core_1.localPreferences.getItem(`${datasetId}_last_auto_refresh_time`);
                const lastRefreshTime = lastRefreshTimeStr ? parseInt(lastRefreshTimeStr, 10) : 0;
                const timeOkToAutoRefresh = lastRefreshTime + (60 * 60 * 1000);
                const now = Date.now();
                if (now >= timeOkToAutoRefresh) {
                    // we are delaying just a bit so user doesn't get a Credential Required or MFA dialog immediately upon login
                    yield (0, effects_1.put)((0, actions_6.setAwaitingToAutoRefresh)(true));
                    yield (0, effects_1.delay)(5000);
                    yield (0, effects_1.call)(startRefreshAccounts, { autoRefresh: true });
                    refreshStarted = true;
                }
            }
            else {
                // @ts-expect-error: No overload matches this call.
                yield (0, effects_1.call)(startRefreshAccounts);
                refreshStarted = true;
            }
            if (refreshStarted) {
                yield (0, effects_1.take)(actions_4.refreshAccountsCompleted);
                yield (0, effects_1.put)((0, actions_6.setAwaitingToAutoRefresh)(false));
            }
            // even if create job status fails, need to still delete job status (for reducer benefit)
            yield (0, effects_1.put)((0, actions_3.deleteJobStatus)({ id: (_b = createJobStatusSuccessAction === null || createJobStatusSuccessAction === void 0 ? void 0 : createJobStatusSuccessAction.payload) === null || _b === void 0 ? void 0 : _b.id })); // it's a hack - refresh is complete, but fetch still is in progress
            yield (0, effects_1.put)(datasets_1.datasetsActions.getDatasets()); // another hack to ensure that lastSyncedAt is up to date
            yield (0, effects_1.put)(userInfoActions.getUserInfo());
        }
    }
    log.info('refresh (complete)<-');
}
// TODO: switch to web socket - and remove method below
function* fetchRefreshedData() {
    log.log('fetch data (refreshed)...');
    (0, balCache_1.clearBalancesCache)();
    yield (0, effects_1.put)(accounts_1.accountsActions.getAccounts());
    yield (0, effects_1.call)(fetchInstitutionLoginsIfAnyConnectedAccountExists);
    yield (0, effects_1.put)(transactions_1.transactionsActions.getTransactions());
    let currentDataset = yield (0, effects_1.select)(auth_1.authSelectors.getCurrentDataset);
    while (!currentDataset || !currentDataset.entitlements) {
        yield (0, effects_1.delay)(100);
        currentDataset = yield (0, effects_1.select)(auth_1.authSelectors.getCurrentDataset);
    }
    const { isEntityShare } = (0, accountGroupUtils_1.getDatasetAccessControlData)(currentDataset);
    const featureFlags = yield (0, effects_1.select)(feature_flags_1.featureFlagsSelectors.getFeatureFlags);
    if (!isEntityShare && featureFlags.get('budgets')) {
        yield (0, effects_1.put)(budget_items_1.budgetItemsActions.getBudgetItemsAction());
    }
    yield (0, effects_1.put)((0, actions_5.getInvestmentAccounts)());
    yield (0, effects_1.put)((0, actions_1.getInvestmentHoldings)());
    if (!isEntityShare && (featureFlags.get('scheduledTransactions') || featureFlags.get('scheduledTransactionsInRegister'))) {
        yield (0, effects_1.put)(scheduled_transactions_1.scheduledTransactionsActions.getScheduledTransactions());
    }
    // QCS doesn't support incremental updates for IRR and TWR now - not providing query params startOn/endOn/accountIds would cause http500
    // if (featureFlags.get('investment-performance')) {
    //   yield put(getInvestmentPerformance());
    //   yield put(getInvestmentIRR());
    // }
}
// =================================================================================================
// upsertPushNotificationToken
// =================================================================================================
function* upsertPushNotificationToken({ payload: token }) {
    var _a;
    log.info('upsertPushNotificationToken called...', token);
    const datasetId = yield (0, effects_1.select)(auth_1.authSelectors.getDatasetId);
    const requestUrl = `${(_a = (0, core_1.getEnvironmentConfig)()) === null || _a === void 0 ? void 0 : _a.services_url}/messenger/push-token`;
    const requestData = {
        datasetId,
        tokenType: 'FCM',
        pushToken: token,
        devicePlatform: 'web',
    };
    try {
        const response = yield (0, effects_1.call)(qcsAxios.post, requestUrl, requestData);
        log.info('upsertPushNotificationToken response...', response);
        // yield put(actions.searchForInstitutionsSuccess(institutions));
    }
    catch (error) {
        log.error('upsertPushNotificationToken error...', error);
        // yield put(actions.searchForInstitutionsFailure(error));
    }
}
// =============================================================================
// Watchers
// =============================================================================
function* appHistoryPushActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.appHistoryPush, appHistoryPush);
}
function* appHistoryReplaceActionWatcher() {
    yield (0, effects_1.takeEvery)(actions.appHistoryReplace, appHistoryReplace);
}
function* appRefreshAllActionWatcher() {
    yield (0, effects_1.takeLeading)(actions.appRefreshAll, appRefreshAll);
}
function* refreshAccountsCompletedActionWatcher() {
    yield (0, effects_1.takeLeading)(actions_4.refreshAccountsCompleted, fetchRefreshedData);
}
function* upsertPushNotificationTokenWatcher() {
    yield (0, effects_1.takeLeading)(actions.appSubmitPushNotificationToken, upsertPushNotificationToken);
}
exports.default = [
    appHistoryPushActionWatcher,
    appHistoryReplaceActionWatcher,
    appRefreshAllActionWatcher,
    refreshAccountsCompletedActionWatcher,
    upsertPushNotificationTokenWatcher,
];
